import { render, staticRenderFns } from "./expoForm.vue?vue&type=template&id=204f7cc2&scoped=true"
import script from "./expoForm.vue?vue&type=script&lang=js"
export * from "./expoForm.vue?vue&type=script&lang=js"
import style0 from "./expoForm.vue?vue&type=style&index=0&id=204f7cc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204f7cc2",
  null
  
)

export default component.exports